import styled from 'styled-components'
import { Box } from '../../../shared_components/UI/Box'
import { defaultTransition } from '../../../theme'
import { getRgbaValue } from '../../../utils/styling'
import { PoolButton } from '../../PoolDetails/parts'
import { ChainIcon as Icon } from '../../../shared_components/Chains/FilterToggleBox'

export const Container = styled(Box)`
  flex-direction: column;
  margin-top: 56px;
  z-index: 100000;
`

export const AllocationCard = styled(Box)<{
  isOpen: boolean
  isExternal?: boolean
}>`
  flex-direction: column;
  ${defaultTransition}
  max-height:${({ isOpen, isExternal }) =>
    isOpen ? (isExternal ? 400 : 2000) : 80}px;
  overflow: hidden;
  z-index: 20;
  @media screen and (max-width: 850px) {
    max-height: ${({ isOpen, isExternal }) =>
      isOpen ? (isExternal ? 800 : 1400) : 148}px;
    border-bottom: 1px solid
      ${({ theme }) => getRgbaValue(theme.semantics.zap.surface.primary, 0.3)};
    padding-bottom: 48px;
  }
`

export const ExternalText = styled.span`
  opacity: 0.5;
`

export const LogoAndTitle = styled(Box)`
  @media screen and (max-width: 850px) {
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }
`

export const TopBar = styled(Box)`
  justify-content: space-between;
  min-height: 80px;
  align-items: center;
  @media screen and (max-width: 850px) {
    min-height: 148px;
    padding-top: 32px;
    justify-content: flex-start;
    align-items: flex-start;
  }
`

export const BottomContent = styled(Box)`
  min-height: 387px;
`

export const Logo = styled.img`
  height: 40px;
  width: 40px;
  max-width: 40px;
  max-width: 40px;
  margin-right: 16px;
  border-radius: 250px;

  @media screen and (max-width: 850px) {
    margin-bottom: 16px;
  }
`

export const TokenName = styled.span`
  font-style: normal;
  font-size: 20px;
  line-height: 25px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
`

export const ChainIcon = styled(Icon)`
  margin-right: 32px;
  opacity: 0.5;
  width: 40px;
  filter: saturate(0) invert(1) !important;
`

export const Button = styled.button<{ isOpen: boolean }>`
  min-width: 44px;
  transform: scaleY(${({ isOpen }) => (isOpen ? 1 : -1)});
  filter: invert(0) !important;
  img {
    height: 44px;
    width: 44px;
  }
`

export const PointCard = styled(Box)<{ disabled: boolean; index: number }>`
  min-height: 220px;
  max-width: 300px;
  margin-top: 32px;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  background: #030b11;
  box-sizing: border-box;
  border-radius: 18px;
  margin-bottom: 8px;
  padding: 16px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-right: 16px;
  @media screen and (max-width: 500px) {
    max-width: calc(100vw - 64px);
    min-width: calc(100vw - 64px);
  }
`

export const Month = styled.span`
  font-style: normal;
  font-weight: 200;
  font-size: 14px;
  line-height: 16px;
  text-align: center;
  opacity: 0.4;
`

export const Day = styled.span`
  font-style: normal;
  font-weight: 100;
  font-size: 32px;
  line-height: 40px;
  text-align: center;
  margin-left: 8px;
`

export const DateBox = styled(Box)`
  align-items: center;
`

export const PointLabel = styled.span`
  font-size: 14px;
  line-height: 18px;
  text-transform: uppercase;
  margin-top: 12px;
`

export const Details = styled.span`
  font-weight: 300;
  margin-top: 4px;
  font-family: 'Space Grotesk';
  font-size: 16px;
  line-height: 24px;
  opacity: 0.6;
`

export const ZoomIn = styled.div<{ isOpen: boolean; index: number }>`
  width: 100%;
  max-width: 240px;
  min-height: 220px;
  margin-right: 16px;
  opacity: ${({ isOpen }) => (isOpen ? 1 : 0)};
  transform: translateX(${({ isOpen }) => (isOpen ? 0 : -40)}px);
  transition: 0.3s ease-in-out;
  transition-delay: ${({ index }) => index * 0.15 + 0.6}s;
`

export const ProgressBarContainer = styled.div`
  height: 14px;
  position: relative;
  width: 100%;
  margin-top: 20px;
  overflow: hidden;
  border-radius: 6px;
  ${defaultTransition}
  :before {
    content: '';
    position: absolute;
    width: 100%;
    border-radius: 6px;
    background: ${getRgbaValue('#f4ed0c', 0.5)};
    height: 14px;
    top: -1px;
    z-index: -3;
  }
  :after {
    content: '';
    border-radius: 6px;
    position: absolute;
    width: calc(100% - 2px);
    left: 1px;
    height: 11px;
    top: 1px;
    z-index: -2;
    background: radial-gradient(
        120.71% 111.76% at 89% -40%,
        rgba(202, 65, 226, 0.2) 0%,
        rgba(63, 93, 255, 0) 100%
      )
      #101112;
  }
`

export const Bar = styled.div<{ progress: number; isOpen: boolean }>`
  background: #f4ed0c;
  height: 13px;
  z-index: 20;
  transform-origin: left;
  transition-delay: ${({ isOpen }) => `${!isOpen ? 0.6 : 0.3}s`};
  transform: scaleX(${({ isOpen }) => (isOpen ? 1 : 0)});
  width: ${({ progress }) => progress}%;
  transition: 0.3s ease-in-out;
`

export const BarLabel = styled.span`
  font-family: 'Space Grotesk';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  color: ${({ theme }) => theme.semantics.zap.surface.primary};
  margin-bottom: -16px;
  margin-top: 8px;
`

export const ClaimButton = styled(PoolButton)`
  width: 188px;
  height: 48px;
  padding: 0;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: -0.01em;
  font-feature-settings: 'ss01' on;
`
export const PointsContainer = styled(Box)`
  @media screen and (max-width: 850px) {
    flex-wrap: wrap;
  }
`

export const LoadingContainer = styled(Box)`
  flex: 1;
  width: 100%;
  min-height: 300px;
  align-items: center;
  justify-content: center;
`

export const PsuedoButton = styled(Box)`
  width: 144px;
  height: 20px;

  justify-content: center;
  align-items: center;
  background: #f4ed0c;
  border-radius: 4px;

  font-family: 'Space Grotesk';
  font-style: normal;
  font-weight: 500;
  font-size: 11px;
  line-height: 12px;

  margin-right: -16px;

  text-transform: uppercase;
  span {
    color: #000000;
  }
`

export const FakeButton = styled(PsuedoButton)<{
  disabled: boolean
  hasClaimed: boolean
}>`
  margin-top: 12px;
  max-height: 20px;
  color: ${({ theme, hasClaimed, disabled }) =>
    hasClaimed || disabled
      ? theme.colors.brandPrimary
      : !disabled
      ? '#000'
      : '#000'};
  background: ${({ disabled, theme, hasClaimed }) =>
    disabled || hasClaimed ? '#0F0F11' : theme.colors.brandPrimary};
`

export const WrongChainWarning = styled(Box)`
  margin-top: 16px;
  span {
    text-transform: capitalize;
    margin: 0 6px;
  }
`
